import { render } from "./TipTapMenuBar.vue?vue&type=template&id=647e64de"
import script from "./TipTapMenuBar.vue?vue&type=script&lang=js"
export * from "./TipTapMenuBar.vue?vue&type=script&lang=js"

import "./TipTapMenuBar.vue?vue&type=style&index=0&id=647e64de&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__